import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class EmployeePostadjustApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'employee-postadjust'
  }

}